import * as _pluralize from 'pluralize';

export default function (word, amount) {
  return _pluralize(word, amount);
}
